/* eslint-disable no-alert */
import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "results-grid-content",
  class ResultsGridContent extends WYATTElement {
    constructor() {
      super();

      this.grid = document.getElementById(this.config.gridId);

      if (this.grid) {
        this.inject();
      }
    }

    inject() {
      const sibling = this.grid.children[this.config.position];

      if (!sibling) {
        return;
      }

      const gridItem = document.createElement("div");

      gridItem.className = "results-grid__item";
      gridItem.style.setProperty("--column-span", this.config.columnSpan);

      gridItem.appendChild(this);

      sibling.insertAdjacentElement("beforebegin", gridItem);
    }
  },
);
